import { Pill } from '@mantine/core';

import { PublicationIdentifiers } from '@/module/Author/Publication/model/PublicationTypes';

interface PublicationCardIdentifiersProps {
  identifiers: PublicationIdentifiers;
}

export function PublicationCardIdentifiers({ identifiers }: PublicationCardIdentifiersProps) {
  return (
    <>
      {identifiers.doi && <Pill>{identifiers.doi}</Pill>}
      {identifiers.wosId && <Pill>WOS:{identifiers.wosId}</Pill>}
      {identifiers.scopusId && <Pill>SCOPUS:{identifiers.scopusId}</Pill>}
    </>
  );
}
